export default __webpack_public_path__ + "static/media/avatar_siti2.a4988c59.mp3";